<script>
import {VesselService} from "@/services/VesselService";
import { toBlob } from 'dom-to-image-more';

export default {
  name: "SummaryTotalCrewBarGraph",
  data() {
    return {
      crewFilterType : [
        {
          name : 'Total Number of ONBOARD Crews',
          onboard : true,
        },
        {
          name : 'Total Number of Crews',
          onboard : false,
        },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          toolbar: {
            tools: {
              download: false
            }
          },
          events: {
            xAxisLabelClick: function(event, chartContext, config){
              this.setModalData({
                dataPointIndex : config.labelIndex,
                seriesIndex : 1,
              });
              $('#summary_total_crew_modal').modal('show');
            }.bind(this),
            dataPointSelection: (event, chartContext, config) => {
              this.filterIsOnboard = config.seriesIndex === 0;
              this.setModalData(config);
              $('#summary_total_crew_modal').modal('show');
            }
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '90%',
            borderRadius: 4,
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#000000', '#000000']
          }
        },
        title: {
          text: 'Total Crew (Per Rank)',
          align: 'center'
        },
        colors: ['#01a1e7', '#C0C0C0'],
        legend: {
          position: "bottom",
        },
        xaxis: {
          categories: null
        }
      },
      selectedDataForModal : null,
      filterIsOnboard : true,
    }
  },
  methods : {
    async getGraphImage() {
      swal.fire({
        'title': `Exporting Summary Per Rank of Crew`,
        'text': "Please wait...",
        'imageUrl': "https://img.icons8.com/external-tal-revivo-tritone-tal-revivo/64/external-horizontal-bar-graph-chart-isolated-on-a-white-background-business-tritone-tal-revivo.png",
        'imageWidth': 100,
        'imageHeight': 100,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()

      const blob = await toBlob(this.$refs["apex-chart-total-crew-type"].chart.el, {
        pixelRatio: 2,
        backgroundColor: 'white'
      });

      const formData = new FormData();
      formData.append("chart_image", blob, "chart.png");
      formData.append("report_type", 'Summary Per Rank of Crew');


      const printResponse = await VesselService.printSummaryOfManagingVesselGraph(formData);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([printResponse.data],{type:'application/pdf'}))
      let filename=`summary_per_rank_of_crew_${Date.now()}.pdf`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    getCategories() {
      if (this.fullData.length === 0) {
        return [];
      }
      return this.fullData[0]?.totalCrewPerRank.map(item => item.name);
    },
    setModalData(config) {
      this.selectedDataForModal = {
        rank_name : this.chartOptions.xaxis.categories[config.dataPointIndex],
        full_data_index : config.dataPointIndex,
        data : this.fullData.map(item => {
          if (config.seriesIndex === 0) {
            return item.totalOnboardCrewPerRank.map(totalCrew => {
              return totalCrew.total;
            })[config.dataPointIndex]
          }
          return item.totalCrewPerRank.map(totalCrew => {
            return totalCrew.total;
          })[config.dataPointIndex]
        }),
        data_map : config.seriesIndex === 0 ? 'totalOnboardCrewPerRank' : 'totalCrewPerRank',
        data_type :  config.seriesIndex === 0 ? 'onboard' : '',
        current_config: config
      };
    },
    changeModalData() {
      const config = Object.assign({}, this.selectedDataForModal.current_config);
      config.seriesIndex = this.filterIsOnboard === true ? 0 : 1;
      this.setModalData(config);
    }
  },
  props: {
    fullData : {
      type : Array,
      default: []
    }
  },
  computed : {
    summaryTotalCrewModalTableHeaders() {
      return [
        ...['ranks'],
        ...this.fullData.map(item => item.alias),
        ...['Total Crew (Per Rank)']];
    },

    series() {
      const ranks = this.fullData[0]?.totalCrewPerRank.map(item => {
        return item.name;
      })
      return [
        {
          name : 'Total On Board Crew Per Rank',
          data : ranks.map(rank_name => {
            return this.fullData.map(data => {
              return data.totalOnboardCrewPerRank.filter(crew_rank => {
                return crew_rank.name === rank_name
              })[0]
            }).map(item => item.total).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
          })
        },
        {
          name : 'Total Crew Per Rank',
          data : ranks.map(rank_name => {
            return this.fullData.map(data => {
             return data.totalCrewPerRank.filter(crew_rank => {
               return crew_rank.name === rank_name
             })[0]
            }).map(item => item.total).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
          })
        },
      ];
    },
    apexChartHeight() {
      return this.summaryTotalCrewModalTableHeaders.length * 86;
    }
  },
  created() {
    this.chartOptions.xaxis.categories = this.getCategories();
  }
}
</script>

<template>
  <div class="bar-chart-container" id="bar-chart-container">
    <apexchart ref="apex-chart-total-crew-type" style="max-width: 100%; min-width: 100%" type="bar" :height="apexChartHeight" :options="chartOptions"
               :series="series"></apexchart>

    <div class="modal fade" id="summary_total_crew_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <select class="ml-2 form-control form-control-sm text-uppercase w-auto" id="auditor_department_id" v-model="filterIsOnboard" @change="changeModalData">
              <option :value="item.onboard" v-for="item in crewFilterType">{{ item.name }}</option>
            </select>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-bordered mr-1">
                  <thead>
                  <tr>
                    <template v-for="header in summaryTotalCrewModalTableHeaders">
                      <template v-if="header === 'Total Crew (Per Rank)'">
                        <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; border-bottom: 3px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 5px solid #676767; min-width: 105px;">{{ header }}</th>
                      </template>
                      <template v-else>
                        <th class="text-center text-uppercase align-middle" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">{{ header }}</th>
                      </template>
                    </template>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th class="text-right text-uppercase white-space-no-wrap" style="background-color: #e1e1e1; border: 1px solid #c3c3c3; max-width: 500px;">{{selectedDataForModal?.rank_name}}</th>
                    <template v-for="(item, item_index) in selectedDataForModal?.data">
                      <template v-if="item === 0">
                        <td class="text-center align-middle">{{item}}</td>
                      </template>
                      <template v-else>
                        <td class="text-center align-middle text-primary font-weight-bold" @click="$emit('showDataFromCms', fullData[item_index][selectedDataForModal.data_map][selectedDataForModal.full_data_index], fullData[item_index], selectedDataForModal.data_type)" style="cursor: pointer" title="Click to view crew list">
                          {{item}}
                        </td>
                      </template>
                    </template>
                    <td class="text-center align-middle" style="background-color: #c9c9c9; border-bottom: 1px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 5px solid #676767;">{{ selectedDataForModal?.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0) }} </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>
